import React, { useState } from "react";
import { Icons } from "./icons.jsx";
import { Pill, ActionButton } from "./primitives.jsx";
import HoverVideoArt from "./HoverVideoArt.jsx";
import {
  ProgramCardRoot,
  ProgramCardBody,
  ProgramCardTitle,
  ProgramCardBlurb,
  ProgramCardTagsRow,
  ProgramCardMeta,
  ProgramCardMetaItem,
  ProgramCardActions,
  ProgramCardFeaturedBadge,
} from "./style.js";

// ── ProgramCard ───────────────────────────────────────────────────────────────
const ProgramCard = ({ program, playToken, onAskPlay, onPreview, onOpen }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <ProgramCardRoot
      $hovered={hovered}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => onOpen(program)}
    >
      <HoverVideoArt
        program={program}
        hovered={hovered}
        playToken={playToken}
        onAskPlay={onAskPlay}
      />
      <ProgramCardBody>
        <ProgramCardTitle>{program.name}</ProgramCardTitle>
        <ProgramCardBlurb>{program.short_description || ""}</ProgramCardBlurb>
        <ProgramCardTagsRow>
          {(program.tags ?? []).map((t) => (
            <Pill key={t} tone="tag" size="sm">
              {t}
            </Pill>
          ))}
        </ProgramCardTagsRow>
        <ProgramCardMeta>
          {[
            [<Icons.clock size={14} />, program.duration],
            [<Icons.star size={14} />, program.rating],
            [<Icons.book size={14} />, `${program.lesson_count} Skill Sessions`],
            [
              <Icons.users size={14} style={{ color: "currentColor" }} />,
              `${program.sim_count} Simulations`,
            ],
          ].map(([icon, val], i) => (
            <ProgramCardMetaItem key={i} $isRating={i === 1}>
              {icon}
              {val}
            </ProgramCardMetaItem>
          ))}
        </ProgramCardMeta>
      </ProgramCardBody>
      <ProgramCardActions>
        <ActionButton
          variant="primary"
          size="sm"
          icon={<Icons.zap size={14} />}
          onClick={(e) => {
            e.stopPropagation();
            onPreview(program);
          }}
        >
          Start for Free
        </ActionButton>
        <ActionButton
          variant="purpleOutline"
          size="sm"
          iconRight={<Icons.arrowRight size={14} />}
          onClick={(e) => {
            e.stopPropagation();
            onOpen(program);
          }}
        >
          Explore
        </ActionButton>
      </ProgramCardActions>
      {program.is_featured && (
        <ProgramCardFeaturedBadge>
          <Icons.sparkle size={12} /> Most loved
        </ProgramCardFeaturedBadge>
      )}
    </ProgramCardRoot>
  );
};

export default ProgramCard;
